var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import Modal from '@spa/shared/components/Modal';
import Button from '@spa/shared/components/Unisystem/Button';
import { multipleLines } from '@spa/shared/utils/i18next';
import IgnacioValentine from '@spa/shared/svg/inacio-valentine';
import { ActionsWrapper, ContentWrapper, ModalGlobalStyle } from './styles';
var Wishlist = function Wishlist(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleSignUp = function handleSignUp() {
    window.location.href = "".concat(process.env.APP_URL, "signup?from=property&context=wish-list-modal-offer");
  };
  var handleLogIn = function handleLogIn() {
    window.location.href = "".concat(process.env.APP_URL, "login");
  };
  return __jsx(Modal, {
    title: t('Like this listing?'),
    onClose: onClose,
    className: "wishlist"
  }, __jsx(ModalGlobalStyle, null), __jsx(ContentWrapper, null, __jsx(IgnacioValentine, null), __jsx("p", null, multipleLines(t(
  // eslint-disable-next-line quotes
  "By logging in to your account you'll be able to save and view all your favourite places. If you don't have an account yet, what are you waiting for?")))), __jsx(ActionsWrapper, null, __jsx(Button, {
    isPrimary: true,
    onClick: handleSignUp
  }, t('Sign up')), __jsx(Button, {
    isSecondary: true,
    onClick: handleLogIn
  }, t('Log in'))));
};
export default Wishlist;